import ReagreeWaiverConfirm from './ReagreeWaiverConfirm'

export default ReagreeWaiverConfirm
